import { CurrencyFacade } from './../../../../../epims-references/src/lib/states/+currency/currency.facade';
import { EpimsBankDetailDto } from './../../../../../data/src/lib/dto/epimsbank-detail.dto';
import { EpimsBankDetailFacade } from './../../../../../epims-references/src/lib/states/+bankDetail/bank-detail.facade';
import { EpimsBankFacade } from './../../../../../epims-references/src/lib/states/+bank/bank.facade';
import { ScholarshipPaymentDto } from './../../../../../data/src/lib/dto/scholarship-payment.dto';
import { ScholarshipTypeFacade } from './../../../../../epims-references/src/lib/states/+scholarshiptype/scholarshiptype.facade';
import { StateFacade } from './../../../../../epims-references/src/lib/states/+state/state.facade';
import { GenderFacade } from './../../../../../epims-references/src/lib/states/+gender/gender.facade';
import { CourseOfStudyFacade } from './../../../../../epims-references/src/lib/states/+courseofstudy/courseofstudy.facade';
import { CommunityFacade } from './../../../../../epims-references/src/lib/states/+community/community.facade';
import { ScholarshipAwardDurationFacade } from './../../../../../epims-references/src/lib/states/+scholarshipawardduration/scholarshipawardduration.facade';
import { ScholarshipSessionFacade } from './../../../../../epims-references/src/lib/states/+scholarshipsession/scholarshipsession.facade';
import { ScholarshipCategoryFacade } from './../../../../../epims-references/src/lib/states/+scholarshipcategory/scholarshipcategory.facade';
import { LgaFacade } from './../../../../../epims-references/src/lib/states/+lga/lga.facade';
import { CountryFacade } from './../../../../../epims-references/src/lib/states/+country/country.facade';
import { Component, OnInit } from '@angular/core';

import { Observable, observable, Subscription } from 'rxjs';
import {
  ScholarshipManagementDto,
  CountryDto,
  StateDto,
  LgaDto,
  ScholarshipTypeDto,
  ScholarshipCategoryDto,
  ScholarshipSessionDto,
  ScholarshipAwardDurationDto,
  CommunityDto,
  CourseOfStudyDto,
  EpimsGenderDto,
  EpimsBankDto,
  CurrencyDto,
} from '@cradua/data';
import { ScholarshipManagementFacade } from '../../states/+scholarship-management/scholarship-management.facade';
import { ScholarshipPaymentFacade } from '../../states/+scholarship-payment/scholarship-payment.facade';

@Component({
  selector: 'mrsoftapps-scholarship-management-container',
  templateUrl: './scholarship-management-container.component.html',
  styleUrls: ['./scholarship-management-container.component.scss'],
})
export class ScholarshipManagementContainerComponent implements OnInit {
  isLoadingScholarshipManagement$: Observable<any>;
  isLoadingCountry$: Observable<any>;
  isLoadingState$: Observable<any>;
  isLoadingLga$: Observable<any>;
  isLoadingScholarshipType$: Observable<any>;
  isLoadingScholarshipCategory$: Observable<any>;
  isLoadingScholarshipSession$: Observable<any>;
  isLoadingScholarshipAwardDuration$: Observable<any>;
  isLoadingCommunity$: Observable<any>;
  isLoadingCourseOfStudy$: Observable<any>;
  isLoadingGender$: Observable<any>;
  isLoadingScholarshipPayment$: Observable<any>;
  isLoadingBank$: Observable<any>;
  isLoadingBankDetail$: Observable<any>;
  isLoadingCurrency$: Observable<any>;

  scholarshipManagement$: Observable<ScholarshipManagementDto[]>;
  searchScholarshipManagement$: Observable<ScholarshipManagementDto[]>;
  country$: Observable<CountryDto[]>;
  state$: Observable<StateDto[]>;
  lga$: Observable<LgaDto[]>;
  scholarshipType$: Observable<ScholarshipTypeDto[]>;
  scholarshipCategory$: Observable<ScholarshipCategoryDto[]>;
  scholarshipSession$: Observable<ScholarshipSessionDto[]>;
  scholarshipAwardDuration$: Observable<ScholarshipAwardDurationDto[]>;
  community$: Observable<CommunityDto[]>;
  courseOfStudy$: Observable<CourseOfStudyDto[]>;
  gender$: Observable<EpimsGenderDto[]>;
  bank$: Observable<EpimsBankDto[]>;
  bankDetail$: Observable<EpimsBankDetailDto[]>;
  scholarshipPayment$: Observable<ScholarshipPaymentDto[]>;
  currency$: Observable<CurrencyDto[]>;
  scholarshipData: ScholarshipManagementDto;
  task = 'list';
  bankDetails: any[];
  sub: Subscription;
  constructor(
    private scholarshipManagementFacade: ScholarshipManagementFacade,
    private countryFacade: CountryFacade,
    private stateFacade: StateFacade,
    private lgaFacade: LgaFacade,
    private scholarshipTypeFacade: ScholarshipTypeFacade,
    private scholarshipCategoryFacade: ScholarshipCategoryFacade,
    private scholarshipSessionFacade: ScholarshipSessionFacade,
    private scholarshipAwardDurationFacade: ScholarshipAwardDurationFacade,
    private communityFacade: CommunityFacade,
    private courseOfStudyFacade: CourseOfStudyFacade,
    private genderFacade: GenderFacade,
    private scholarshipPaymentFacade: ScholarshipPaymentFacade,
    private bankFacade: EpimsBankFacade,
    private bankDetailFacade: EpimsBankDetailFacade,
    private currencyFacade: CurrencyFacade
  ) {}

  ngOnInit() {
    this.isLoadingScholarshipManagement$ = this.scholarshipManagementFacade.isLoadingScholarshipManagement;
    this.isLoadingCountry$ = this.countryFacade.isLoadingCountry;
    this.isLoadingState$ = this.stateFacade.isLoadingState;
    this.isLoadingLga$ = this.lgaFacade.isLoadingLga;
    this.isLoadingCommunity$ = this.communityFacade.isLoadingCommunity;
    this.isLoadingCourseOfStudy$ = this.courseOfStudyFacade.isLoadingCourseOfStudy;
    this.isLoadingScholarshipAwardDuration$ = this.scholarshipAwardDurationFacade.isLoadingScholarshipAwardDuration;
    this.isLoadingScholarshipSession$ = this.scholarshipSessionFacade.isLoadingScholarshipSession;
    this.isLoadingScholarshipType$ = this.scholarshipTypeFacade.isLoadingScholarshipType;
    this.isLoadingScholarshipCategory$ = this.scholarshipCategoryFacade.isLoadingScholarshipCategory;
    this.isLoadingGender$ = this.genderFacade.isLoadingGender;
    this.isLoadingBank$ = this.bankFacade.isLoadingEpimsBank;
    this.isLoadingCurrency$ = this.currencyFacade.isLoadingCurrency;
    // this.isLoadingBankDetail$ = this.bankDetailFacade.isLoadingEpimsBankDetail;

    this.country$ = this.countryFacade.loadCountry;
    this.state$ = this.stateFacade.loadState;
    this.lga$ = this.lgaFacade.loadLga;
    this.community$ = this.communityFacade.loadCommunity;
    this.courseOfStudy$ = this.courseOfStudyFacade.loadCourseOfStudy;
    this.scholarshipAwardDuration$ = this.scholarshipAwardDurationFacade.loadScholarshipAwardDuration;
    this.scholarshipType$ = this.scholarshipTypeFacade.loadScholarshipType;
    this.scholarshipSession$ = this.scholarshipSessionFacade.loadScholarshipSession;
    this.scholarshipCategory$ = this.scholarshipCategoryFacade.loadScholarshipCategory;
    this.gender$ = this.genderFacade.loadGender;
    this.bank$ = this.bankFacade.loadEpimsBank;
    this.scholarshipPayment$ = this.scholarshipPaymentFacade.getScholarshipPaymentData;

    this.bankDetail$ = this.bankDetailFacade.getAllBankDetailById;
    this.currency$ = this.currencyFacade.loadCurrency;

    this.sub = this.bankDetail$.subscribe((data) => {
      this.bankDetails = data.map((item) => {
        return {
          BankName: item.BankName,
          SortCode: item.SortCode,
          BeneficiaryAccountName: item.BeneficiaryAccountName,
          BeneficiaryAccountNumber: item.BeneficiaryAccountNumber,
          Branch: item.Branch,
          Remark: item.Remark,
          BVN: item.BVN,
          StudentId: item.StudentId,
          id: item.id,
        };
      });
    });
  }

  uploadEmit(value) {
    this.scholarshipManagementFacade.uploadExcelScholarshipManagement(value);
  }

  taskEmit(value) {
    this.task = value;
    if (value === 'list') {
      this.scholarshipManagementFacade.searchStudentRecord('');
    }
  }

  deleteBankDetail(value) {
    this.bankDetailFacade.removeEpimsBankDetail(value);
  }

  createBankDetail(formValue) {
    const pullData = formValue.BankDetails;

    // declare two empty array to hold update and create data
    let allUpdates = [];
    let addAllBankDetail = [];

    // loop through the form data to check for update and create

    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        addAllBankDetail.push(pullData[i]);
      }
    }

    // check if the addAllCountry array is not empty, then dispatch the data to the store
    if (addAllBankDetail.length !== 0) {
      this.bankDetailFacade.addEpimsBankDetail(addAllBankDetail);
    }

    // check if there is any update on the object
    const getChange = this.getChanges(this.bankDetails, allUpdates);

    // console.log('changed value ', getChange);
    if (getChange) {
      // dispatch update data to the store
      this.bankDetailFacade.updateEpimsBankDetail(allUpdates);
    }
  }

  createEmit(value) {
    if (value.id) {
      // console.log('submmmmm ', value)
      this.scholarshipManagementFacade.updateScholarshipManagement(value);
      this.scholarshipManagementFacade.searchStudentRecord('');
    } else {
      this.scholarshipManagementFacade.addScholarshipManagement(value);
    }
  }

  onSearch(value) {
    this.scholarshipManagementFacade.searchStudentRecord(value);
    this.searchScholarshipManagement$ = this.scholarshipManagementFacade.searchedStudentRecord$;
  }

  onEmitEvent(value: string) {
    this.scholarshipData = null;
    this.task = value;
  }

  onEditEvent(value) {
    this.scholarshipData = value;
    this.task = 'create';
  }

  onReportEvent(value) {
    this.scholarshipData = value;
    this.task = 'report';
  }

  getPayment(id) {
    // console.log('id ', id);
    this.scholarshipPaymentFacade.isLoadingScholarshipPayment(id);
    this.scholarshipPaymentFacade.loadScholarshipPayment(id);
  }

  getBankDetail(id) {
    this.bankDetailFacade.loadEpimsBankDetail(id);
  }

  savePayment(value) {
    this.scholarshipPaymentFacade.addScholarshipPayment(value);
    this.scholarshipManagementFacade.searchStudentRecord('');
    this.task = 'list';
  }

  onViewEvent(value) {
    this.scholarshipData = value;
    this.task = 'view';
  }

  onDeleteEvent(id) {
    this.scholarshipManagementFacade.removeScholarshipManagement(id);
  }

  getChanges(oldArray, newArray) {
    let changes, i, item, j, len;
    if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
      return false;
    }
    changes = [];
    for (i = j = 0, len = newArray.length; j < len; i = ++j) {
      item = newArray[i];
      if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
        changes.push(item);
      }
    }
    return changes;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
